import gql from 'graphql-tag';

import dashboardClusterFragment from './dashboardClusterFragment';

export const dokkioUserDashboardFragment = gql`
  fragment dokkioUserDashboardFragment on DokkioUserDashboard {
    dokkioClass
    id
    status
    statusText
    userInstructions
    dashboardClusters {
      ...dashboardClusterFragment
    }
  }
  ${dashboardClusterFragment}
`;
export default dokkioUserDashboardFragment;
